module.exports = __webpack_public_path__ + "static/media/xls.5be38058.png";